// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { user16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-user': IconUser;
    }
}

/**
 * The icon component for the 'user' icon
 */
export class IconUser extends IconSvg {
    public constructor() {
        super(user16X16);
    }
}

registerIconSvg('icon-user', IconUser);
export const iconUserTag = 'nimble-icon-user';
